import {h, KeepAlive} from 'vue'
import {RouterView} from 'vue-router'

// NuonMomentRoutes
export const NuonMomentRoutes = [
  {
    path: '/moments',
    alias: ['/m'],
    name: 'NuonMoment',
    component: {
      render () {
        return h(RouterView, null, {
          default: ({Component, route}) => h(KeepAlive, null, {
            default: () => h(Component, {
              key: route.fullPath,
            }),
          }),
        })
      },
    },
    children: [
      {
        path: '',
        name: 'NuonMomentIndex',
        component: () => import('@pages/nuon-moment-index/index.vue'),
        meta: {
          title: '诺圈',
        },
      },
      {
        path: ':postId',
        name: 'NuoMomentPostDetail',
        component: () => import('@pages/nuon-moment-post-detail/index.vue'),
        meta: {
          title: '诺圈详情',
        },
      },
      {
        path: 'topic/:topicId',
        name: 'NuonMomentTopicPosts',
        component: () => import('@pages/nuon-moment-topic-posts/index.vue'),
        meta: {
          title: '诺圈',
        },
      },
      {
        path: 'user/:unionId',
        name: 'NuonMomentUserProfile',
        component: () => import('@pages/nuon-moment-user-profile/index.vue'),
        meta: {
          title: '诺圈',
        },
      },
    ],
  },
]
